import { KeyValuePair } from "@dffedb/util";

export class HuskelisteDbMapper {
    public static dbToHuskellister(data: any): KeyValuePair<number, string>[] {
        return data.map((d: any) => this.dbToHuskelliste(d));
    }

    public static dbToHuskelliste(data: any): KeyValuePair<number, string> {
        const result: KeyValuePair<number, string> = {
            key: data.NR,
            value: data.NAVN
        };
        return result;
    }
}
